/** @format */

/**
 * Shape of `Company.sensorGroups` from GraphQL. All three arrays are NON_NULL on the
 * backend, but we accept null/undefined here to defensively handle fragment cache miss.
 */
export type SensorGroupsShape = {
  red?: ReadonlyArray<string> | null;
  yellow?: ReadonlyArray<string> | null;
  gray?: ReadonlyArray<string> | null;
};

/**
 * Concrete (non-nullable) shape of `Company.sensorGroups` after Apollo response has been
 * narrowed by the caller. Used by UI components that receive guaranteed-present arrays.
 */
export type ConcreteSensorGroups = {
  red: ReadonlyArray<string>;
  yellow: ReadonlyArray<string>;
  gray: ReadonlyArray<string>;
};

/**
 * Pure helper that determines whether the project is in "groups mode" — i.e. it has at
 * least one sensor assigned to any criticality group (red ∪ yellow ∪ gray).
 *
 * Result is used to switch the notification form between legacy per-ad-type UI and the
 * new sensor groups selector. See AS-7863 FR-1.
 */
export const isGroupsMode = (sg?: SensorGroupsShape | null): boolean =>
  (sg?.red?.length ?? 0) + (sg?.yellow?.length ?? 0) + (sg?.gray?.length ?? 0) > 0;
